module.exports = __webpack_public_path__ + "media/auth/login-background-5-21eabc23.jpg";